<div *ngIf="address" class="flex-start-center">
    <span>{{ address.fieldName }}</span>
    <span *ngIf="address.value">{{ address.value }}</span>
</div>
